/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".radio__label[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%], .radio__label[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-size:15px;font-weight:0!important;color:#32325d;font-size:1.25rem}.custom-radio[_ngcontent-%COMP%]{line-height:1em}"];
export { styles as styles };

